import { useEffect, useState } from "react";

// Returns a Date that updates every `intervalMs`. Used by components
// that display countdowns so they re-render once per second.
export function useNow(intervalMs = 1000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}
